import React from 'react';

const Sun = ({ className }: { className?: string }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 11.333A3.333 3.333 0 1 0 8 4.667a3.333 3.333 0 0 0 0 6.666Z"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 1.333v1.334M8 13.333v1.334M2.807 2.807l.946.946M12.247 12.247l.946.946M1.333 8h1.334M13.333 8h1.334M2.807 13.193l.946-.946M12.247 3.753l.946-.946"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Sun;
